import React from "react";
import PropTypes from "prop-types";
import { InputField, RadioField } from "../../FormField";

const MedicalQuestionnaireRecord = props => {
  const style = { ...props.style };
  const elements = [];
  let key = 0;

  elements.push(
    <td style={style} key={key++}>
      {props.questionNumber ? props.questionNumber : ""}
    </td>
  );

  let furtherDeclare = null;
  if (props.furtherDeclareDesc) {
    furtherDeclare = <div>{props.furtherDeclareDesc}</div>;
  }

  elements.push(
    <td style={style} key={key++}>
      {props.questionDesc}
      {furtherDeclare}
    </td>
  );

  for (let col = 0; col < props.columns.length; col++) {
    const fieldName = `${props.columns[col]}${props.questionId}`;
    if (props.type === "radio") {
      for (let opt = 0; opt < props.options.length; opt++) {
        elements.push(
          <td key={key++}>
            <RadioField
              radioValue={props.options[opt]}
              name={fieldName}
              style={{
                textAlign: "center",
                ...props.style,
              }}
              {...props.data[fieldName]}
            />
          </td>
        );
      }
    } else if (props.type === "input") {
      elements.push(
        <td colSpan={2} key={key++}>
          <InputField name={fieldName} {...props.data[fieldName]} />
        </td>
      );
    }
  }

  return <tr className={props.type === "radio" ? "question-naire-radio" : ""}>{elements}</tr>;
};

MedicalQuestionnaireRecord.defaultProps = {
  type: "input",
  options: [],
};

MedicalQuestionnaireRecord.propTypes = {
  data: PropTypes.object.isRequired,
  type: PropTypes.string,
  columns: PropTypes.array.isRequired,
  options: PropTypes.array,
  questionNumber: PropTypes.number,
  questionId: PropTypes.string.isRequired,
  questionDesc: PropTypes.string,
  style: PropTypes.object,
  furtherDeclareDesc: PropTypes.string,
};

export default MedicalQuestionnaireRecord;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Aia/AIAHD201906/MedicalQuestionnaireRecord.jsx